import script from "./DiagnosisPane.vue?vue&type=script&lang=ts&setup=true"
export * from "./DiagnosisPane.vue?vue&type=script&lang=ts&setup=true"

import "./DiagnosisPane.vue?vue&type=style&index=0&id=b339b282&lang=scss"

const __exports__ = script;

export default __exports__
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QField from 'quasar/src/components/field/QField.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QMenu,QDialog,QBtnDropdown,QBtn,QList,QItem,QItemSection,QIcon,QItemLabel,QChip,QTooltip,QInput,QField});qInstall(script, 'directives', {ClosePopup});
